import PlayerConstants from "../../../shared/constants/player";
const {
  PLAYER_CONTROLS: { GET_NEXT_LIVE_PROGRAM },
} = PlayerConstants;
export const resetIsLoading = (isLoading) => {
  isLoading.current = false;
};

export const onFullScreenClick = (isFullScreen, setIsInFullScreen, setShowSideNav, showSideNav) => {
  setIsInFullScreen(isFullScreen);
  isFullScreen ? setShowSideNav(showSideNav) : setShowSideNav(false);
};

export const handlePlaybackStateChange = (
  playbackState,
  isLivePlayer,
  updateSidePanelDetails,
  moment,
  playerErrorCodes,
  nonFatalErrorCodes,
  showToastNotification,
  showPlaybackError,
  playbackError,
  dispatch
) => {
  if (isLivePlayer && playbackState === GET_NEXT_LIVE_PROGRAM) {
    updateSidePanelDetails(moment().valueOf());
  }
  if (playbackState.errorType) {
    if (playerErrorCodes.includes(playbackState.code)) {
      console.error("Player error:", playbackState);
      // 2003 is throw when DRM license request failure, this is likely due to stale JWT token that's pass to verimatrix.
      // Short term solution is to request a new token and pass it along to the player to resume playback.
      /*if (playbackState?.code === 2003 && IsSafari()) {
         isTokenRotation.current = true;
        fetchStream(currentAssetId.current, pcPin.current, true);
      }*/
    } else if (nonFatalErrorCodes.includes(playbackState.code)) {
      dispatch(showToastNotification(playbackState.message));
    } else {
      if (!playbackError || Object.values(playbackError).every((value) => value === null)) {
        dispatch(showPlaybackError(playbackState.code, playbackState.message));
      }
    }
  }
};

export const updateSeasonEntitlements = (
  appProvider,
  currentProgram,
  loadCurrentSeasonEntitlements,
  didSeasonChange,
  dispatch
) => {
  const seriesMetadata = currentProgram?.metadata;
  const seriesUaId = seriesMetadata?.extendedMetadata?.dlum?.uaGroupId;
  const seasonNumber = seriesMetadata?.season;
  if (!didSeasonChange.current) {
    dispatch(loadCurrentSeasonEntitlements(appProvider, `${seriesUaId}?season=${seasonNumber}`));
    // reset the flag to resume season entitlement updates again
    didSeasonChange.current = false;
  }
};

export const resetPlayerPage = (
  prevVideoUrl,
  isLoading,
  setHasChannelTuneInfo,
  setIsReadyToChangeStreams,
  preventReadyToChangeStreams
) => {
  prevVideoUrl.current = "";
  resetIsLoading(isLoading);
  setHasChannelTuneInfo(true);
  setIsReadyToChangeStreams(true);
  preventReadyToChangeStreams.current = true;
};
